import { GET } from "generics/base-service";
import { ISpot } from "interfaces/models/spot";

export function fetchingAllSpotByOutletId(outletId: string): Promise<ISpot[]> {
  const url = 'api/v1/Outlet/' + outletId + '/spots';
  return GET<ISpot[]>(url);
}
